export const login = (access_token) => ({
    type: 'LOGIN',
    access_token
});

export const logout = () => ({
    type: 'LOGOUT'
});